import React, { useState } from 'react';
import { triviaList, gifList } from '../data/loadingData.js';

export default function RandomLoadingContent() {
  const [mode] = React.useState(Math.random() < 0.5 ? 'trivia' : 'gif');
  const [trivia] = React.useState(
    triviaList[Math.floor(Math.random() * triviaList.length)]
  );
  const [selectedChoice, setSelectedChoice] = React.useState(null);
  const [isCorrect, setIsCorrect] = React.useState(null);
  const [streak, setStreak] = React.useState(
    () => JSON.parse(localStorage.getItem('triviaStreak')) || 0
  );
  const [prevStreak, setPrevStreak] = React.useState(null);
  const [answered, setAnswered] = React.useState(false);
  const [gif] = React.useState(
    gifList[Math.floor(Math.random() * gifList.length)]
  );

  const checkAnswer = (choice) => {
    const correct = choice === trivia.answer;
    setIsCorrect(correct);
    setAnswered(true);
    setSelectedChoice(choice);

    if (correct) {
      const newStreak = streak + 1;
      setStreak(newStreak);
      localStorage.setItem('triviaStreak', JSON.stringify(newStreak));
    } else {
      setPrevStreak(streak);
      setStreak(0);
      localStorage.setItem('triviaStreak', JSON.stringify(0));
    }
  };

  const fireCount = Math.floor(streak / 3);
  const fireEmojis = '🔥'.repeat(fireCount);

  return (
    <div className="contentBox"
    >
      {mode === 'trivia' ? (
        <>
          <div
            style={{
              fontSize: '16px',
              marginBottom: '22px',
              fontWeight: '600',
            }}
          >
            Quick—before it generates...
          </div>
          <div style={{ fontSize: '24px', marginBottom: '12px' }}>
            {trivia.question}
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              marginBottom: '12px',
            }}
          >
            {trivia.choices.map((choice, idx) => {
              const correctBtn = answered && choice === trivia.answer;
              const wrongBtn =
                answered && choice === selectedChoice && !correctBtn;

              return (
                <button
                  key={idx}
                  onClick={() => checkAnswer(choice)}
                  disabled={answered}
                  className={
                    `magic-button` +
                    (correctBtn ? ' correct' : '') +
                    (wrongBtn ? ' incorrect' : '')
                  }
                >
                  {choice}
                </button>
              );
            })}
          </div>

          {answered && (
            <div style={{ fontSize: '16px', marginTop: '30px' }}>
              {isCorrect ? (
                <span style={{ color: 'green' }}>
                  ✅ Correct! <br />
                  Current Streak: {streak} {fireEmojis}
                </span>
              ) : (
                <span style={{ color: 'red' }}>
                  ❌ Nope, the correct answer was:{' '}
                  <strong>{trivia.answer}</strong>. <br />
                  Previous streak of {prevStreak} is over 😔
                </span>
              )}
            </div>
          )}
        </>
      ) : (
        <>
          <h2
            style={{
              fontSize: '22px',
              marginBottom: '16px',
              letterSpacing: '.05em',
            }}
          >
            Meanwhile…
          </h2>
          <img
            src={gif}
            alt="Loading fun"
            style={{
              width: '360px',
              height: '360px',
              objectFit: 'contain',
              borderRadius: '12px',
              boxShadow: '0 0 0px rgba(0,0,0,0.1)',
            }}
          />
        </>
      )}
    </div>
  );
}
